export default "__VITE_ASSET__Dn1Tq4zn__"